import { type ReactNode } from 'react';
import { ShepherdJourneyProvider } from 'react-shepherd';

interface GuidedTourProps {
  children: ReactNode;
  className?: string;
}

export function GuidedTour({ className, children }: GuidedTourProps) {
  return (
    <div className={className}>
      <ShepherdJourneyProvider>{children}</ShepherdJourneyProvider>
    </div>
  );
}

GuidedTour.displayName = 'GuideTour';
